export default "__VITE_PUBLIC_ASSET__beb6ba67__"